<div class="user-filters-dialog">
  <div class="filter-section">
    <label for="filter-status" class="filter-label">
      {{ 'SETTINGS_ACCESS.USERS.FILTER_BY_STATUS' | translate }}
    </label>
    <p-multiSelect
      inputId="filter-status"
      [options]="statusOptions"
      [ngModel]="selectedStatuses()"
      (ngModelChange)="selectedStatuses.set($event)"
      [placeholder]="'SETTINGS_ACCESS.USERS.FILTER_BY_STATUS' | translate"
      optionLabel="label"
      optionValue="value"
      [showClear]="true"
      class="w-full"
      appendTo="body" />
  </div>

  <div class="filter-section">
    <label for="filter-roles" class="filter-label">
      {{ 'SETTINGS_ACCESS.USERS.FILTER_BY_ROLE' | translate }}
    </label>
    <p-multiSelect
      inputId="filter-roles"
      [options]="roleOptions()"
      [ngModel]="selectedRoleIds()"
      (ngModelChange)="selectedRoleIds.set($event)"
      [placeholder]="'SETTINGS_ACCESS.USERS.FILTER_BY_ROLE' | translate"
      optionLabel="label"
      optionValue="value"
      [showClear]="true"
      [loading]="loadingRoles()"
      class="w-full"
      appendTo="body" />
  </div>

  <div class="filter-section">
    <label for="filter-skills" class="filter-label">
      {{ 'SETTINGS_ACCESS.USERS.FILTER_BY_SKILL' | translate }}
    </label>
    <p-multiSelect
      inputId="filter-skills"
      [options]="skillOptions()"
      [ngModel]="selectedSkillIds()"
      (ngModelChange)="selectedSkillIds.set($event)"
      [placeholder]="'SETTINGS_ACCESS.USERS.FILTER_BY_SKILL' | translate"
      optionLabel="label"
      optionValue="value"
      [showClear]="true"
      [loading]="loadingSkills()"
      class="w-full"
      appendTo="body" />
  </div>

  <div class="filter-section">
    <label for="filter-tags" class="filter-label">
      {{ 'SETTINGS_ACCESS.USERS.FILTER_BY_TAG' | translate }}
    </label>
    <p-multiSelect
      inputId="filter-tags"
      [options]="tagOptions()"
      [ngModel]="selectedTagIds()"
      (ngModelChange)="selectedTagIds.set($event)"
      [placeholder]="'SETTINGS_ACCESS.USERS.FILTER_BY_TAG' | translate"
      optionLabel="label"
      optionValue="value"
      [showClear]="true"
      [loading]="loadingTags()"
      class="w-full"
      appendTo="body">
      <ng-template let-option #item>
        <span class="tag-option">
          <span class="tag-option__dot" [style.background-color]="option.color"></span>
          <span>{{ option.label }}</span>
        </span>
      </ng-template>
    </p-multiSelect>
  </div>

  <div class="dialog-footer">
    <p-button
      [label]="'GENERAL.CLEAR_ALL' | translate"
      severity="secondary"
      [text]="true"
      (onClick)="clearAll()" />
    <div class="footer-actions">
      <p-button
        [label]="'GENERAL.CANCEL' | translate"
        severity="secondary"
        [outlined]="true"
        (onClick)="cancel()" />
      <p-button [label]="'GENERAL.APPLY' | translate" severity="primary" (onClick)="apply()" />
    </div>
  </div>
</div>
